import axios from "axios";
import httpClient from "../httpClient";
import store from "@/store/index";
import {TOKEN_STRING, TokenService} from "../storage.service";

export const interceptorResponse = async (response) => {
  return {
    data: response.data.data,
    resStatusCode: response.status,
    resStatusText: response.statusText,
    resData: response.data,
  };
};

async function getNewToken(error) {
  /*
     * When response code is 401, try to refresh the token.
     * Eject the interceptor so it doesn't loop in case
     * token refresh causes the 401 response
     */
  httpClient._retry = true;

  const refreshToken = store.state?.account?.user.refreshToken ?? null;
  const getRefresh = TokenService.getRefreshToken();

  console.log("refreshToken", refreshToken);
  console.log("getRefreshToken", getRefresh);
  const formData = new FormData()
  formData.append('grant_type', 'refresh_token')
  formData.append('refresh_token', getRefresh || refreshToken)

  console.log("RefreshToken: data", formData);

  const newToken = await axios
      .post(process.env.VUE_APP_HOST_API + "oauth/access_token", formData)
      .then(async (response) => {
        if (response?.data && response.status === 200) {
          const responseAccessToken = response.data.access_token;
          const responseRefreshToken = response.data.refresh_token;

          if (responseAccessToken && responseRefreshToken) {
            TokenService.saveToken(responseAccessToken);
            TokenService.saveRefreshToken(responseRefreshToken);

            store.commit("account/loginSuccess", {
              accessToken: responseAccessToken,
              refreshToken: responseRefreshToken,
            });

            console.log("store.commit");

            error.response.config.headers["Authorization"] =
                TOKEN_STRING + " " + accessToken;
          }
        }
        const _axios = await axios.request(error.response.config);

        return {
          data: _axios.data.data,
          resStatusCode: _axios.status,
          resStatusText: _axios.statusText,
          resData: _axios.data,
        };
      })
      .catch((error) => {
        console.log("http-response-error", error);

        throw error;
      })
      .finally(() => {
        console.log("finally:newToken", newToken);
        console.log(
            "finally:interceptorResponseError",
            interceptorResponseError
        );
      });

  console.log("newToken", newToken);
  console.log("interceptorResponseError", interceptorResponseError);

  return newToken;
}

export const interceptorResponseError = async (error) => {
  console.log("interceptorResponseError:ERROR", error);

  if (error.response === undefined) {
    console.log("error.response", error.response);
    throw error;
  }

  // Reject promise if usual error
  if (error.response && error.response.status !== 401) {
    console.log("error.response.status", error.response.status);

    throw error;
  }

  if (!httpClient._retry) {
    console.log("httpClient._retry", httpClient._retry);
    throw error;
  }

  return await getNewToken(error);
};
